<script setup>
import { useNotificationStore } from '@/store/notifications';
import { storeToRefs } from 'pinia';
import { useTopNavBarStore } from '@/store/topNavBar';
import SelectMonitoringDevice from '@/components/navbartop/SelectMonitoringDevice.vue';
import { useRouter } from 'vue-router';
import { useInstallationDocuments } from '@/composables/useInstallationDocuments';

const router = useRouter();

const {
  rightNav,
  downloadDocument,
} = storeToRefs(useTopNavBarStore());

const { hasNewNotifications } = storeToRefs(useNotificationStore());

const { download } = useInstallationDocuments();
</script>

<template>
  <template v-if="rightNav === 'home'">
    <div class="pr-1">
      <v-btn-action-mobile
        icon="mdi-gift-outline"
        @click="router.push({ name: 'loyalty', state: { backPath: router.currentRoute.value.path } })"
      />
    </div>
    <div>
      <v-badge
        v-model="hasNewNotifications"
        dot
        color="primary"
        location="top start"
      >
        <v-btn-action-mobile
          icon="mdi-bell-outline"
          @click="router.push({ name: 'notifications', state: { backPath: router.currentRoute.value.path } })"
        />
      </v-badge>
    </div>
  </template>

  <div v-else-if="rightNav === 'options-close'">
    <v-btn-action-mobile
      icon="mdi-close"
    />
  </div>

  <div v-else-if="rightNav === 'share-download'">
    <v-btn-action-mobile
      size="x-small"
      variant="tonal"
      icon="mdi-tray-arrow-down"
      :loading="downloadDocument.downloading"
      @click="() => download(downloadDocument)"
    >
      <template #loader>
        <v-progress-circular color="base800" size="20" width="1" indeterminate />
      </template>
    </v-btn-action-mobile>
  </div>

  <v-btn-action-mobile
    v-else-if="rightNav === 'download'"
    icon="mdi-tray-arrow-down"
    :loading="downloadDocument.downloading"
    @click="() => download(downloadDocument)"
  >
    <template #loader>
      <v-progress-circular color="base800" size="20" width="1" indeterminate />
    </template>
  </v-btn-action-mobile>

  <v-btn-action-mobile
    v-else-if="rightNav === 'loyalty'"
    icon="mdi-tray-gift-outline"
    @click="router.push({ name: 'loyalty', state: { backPath: router.currentRoute.value.path } })"
  />

  <select-monitoring-device v-else-if="rightNav === 'monitoring'" />
</template>
